// extracted by mini-css-extract-plugin
module.exports = {"main":"landing-page-module--main--1Jacc","pullHeadline":"landing-page-module--pullHeadline--3Cymt"};